import { msg } from '@/shared/i18n/msg';

/** English keys, translated where they are rendered. */
export const COLLECTION_LABELS: Readonly<Record<string, string>> = {
  items: msg('Inventory'),
  shopping: msg('Shopping'),
  tasks: msg('Tasks'),
  documents: msg('Documents'),
  notes: msg('Notes'),
};
